import React from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import { useTranslation } from "@/translations/TranslationContext";
import "@/components/Services/Services.css";
import imgMonthlyBookkeeping from "@/assets/MonthlyBookkeeping.png";
import iconkey1 from "@/assets/icon_key1.png";
import iconkey2 from "@/assets/icon_key2.png";
import iconkey3 from "@/assets/icon_key3.png";

const BusinessConsulting = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <div className="banner innerbanner banservices_bc">
        <div className="container">
          <div className="inerban">
            <span className="chips">{t.businessConsulting.banner.chips}</span>
            <h1>{t.businessConsulting.banner.title}</h1>
            <p className="text24">
              {t.businessConsulting.banner.subtitle}
            </p>
            <a className="btn btnbanner" href="/contact">
              {t.businessConsulting.banner.button}
            </a>
          </div>
        </div>
      </div>

      <div className="container mb150_75 whatincluded">
        <div className="row">
          <div className="col-lg-6">
            <span className="chips">{t.businessConsulting.included.chips}</span>
            <h2>{t.businessConsulting.included.title}</h2>
            <p className="text24">
              {t.businessConsulting.included.subtitle}
            </p>
            <div className="accordion" id="whatincludedaccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded1"
                    aria-expanded="false"
                    aria-controls="whatincluded1"
                  >
                    {t.businessConsulting.included.sections.startup.title}
                  </button>
                </h2>
                <div
                  id="whatincluded1"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.businessConsulting.included.sections.startup.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded2"
                    aria-expanded="false"
                    aria-controls="whatincluded2"
                  >
                    {t.businessConsulting.included.sections.financial.title}
                  </button>
                </h2>
                <div
                  id="whatincluded2"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.businessConsulting.included.sections.financial.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded3"
                    aria-expanded="false"
                    aria-controls="whatincluded3"
                  >
                    {t.businessConsulting.included.sections.cashFlow.title}
                  </button>
                </h2>
                <div
                  id="whatincluded3"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.businessConsulting.included.sections.cashFlow.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded4"
                    aria-expanded="true"
                    aria-controls="whatincluded4"
                  >
                    {t.businessConsulting.included.sections.growth.title}
                  </button>
                </h2>
                <div
                  id="whatincluded4"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.businessConsulting.included.sections.growth.description}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className="mobmt30"
              src={imgMonthlyBookkeeping}
              alt="imgMonthlyBookkeeping"
            />
          </div>
        </div>
      </div>

      <div className="key_benefits mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 keybenfttext">
              <span className="chips">{t.businessConsulting.benefits.chips}</span>
              <h2>{t.businessConsulting.benefits.title}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="keybenftbox keybenftboxactive">
                <img src={iconkey1} alt="iconkey1" />
                <h4>{t.businessConsulting.benefits.sections.experience.title}</h4>
                <p>
                  {t.businessConsulting.benefits.sections.experience.description}
                </p>
                <a className="btn" href="/contact">
                  {t.businessConsulting.benefits.button}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="keybenftbox">
                <img src={iconkey2} alt="iconkey2" />
                <h4>{t.businessConsulting.benefits.sections.roadmaps.title}</h4>
                <p>
                  {t.businessConsulting.benefits.sections.roadmaps.description}
                </p>
                <a className="btn" href="/contact">
                  {t.businessConsulting.benefits.button}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="keybenftbox">
                <img src={iconkey3} alt="iconkey3" />
                <h4>{t.businessConsulting.benefits.sections.decisions.title}</h4>
                <p>
                  {t.businessConsulting.benefits.sections.decisions.description}
                </p>
                <a className="btn" href="/contact">
                  {t.businessConsulting.benefits.button}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mb150_75 faqs">
        <div className="faqstext">
          <span className="chips">{t.businessConsulting.faq.chips}</span>
          <h2>{t.businessConsulting.faq.title}</h2>
        </div>
        <div className="accordion" id="faqsaccordion">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {t.businessConsulting.faq.questions.startup.question}
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.businessConsulting.faq.questions.startup.answer}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                {t.businessConsulting.faq.questions.industries.question}
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.businessConsulting.faq.questions.industries.answer}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                {t.businessConsulting.faq.questions.implementation.question}
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.businessConsulting.faq.questions.implementation.answer}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BusinessConsulting;
